import styled, { css } from 'styled-components';
import { DESKTOP_MEDIA_QUERY, MOBILE_MEDIA_QUERY } from '~/constants';
import { hideOnDesktop, hideOnMobile } from '~/utils/styles';

export const PolicyWrapper = styled.div`
  width: 100%;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 8.79%;
    padding-bottom: 4.17%;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 23.87%;
    padding-bottom: 10.67%;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #050825;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 2.08vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 4vw;
  }
`;

export const PolicyContainer = styled.div`
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 69.51%;
    padding-top: 8.79%;
    padding-bottom: 4.7%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 85.49%;
    padding-top: 10.29%;
    padding-bottom: 30.9%;
  }
`;

export const Text = styled.p`
  width: 100%;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #050825;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.97vw;
    line-height: 1.71;
    padding-bottom: 1.71em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.13vw;
    line-height: 1.88;
    padding-bottom: 1.88em;
  }
`;

export const BackButtonContainer = styled.div`
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 26.39%;
    padding-bottom: 3.75%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 50.67%;
    padding-bottom: 5.76%;
  }
`;

export const LeftSideBox = styled.div`
  width: 21.05%;
  position: relative;
  background-color: #d8e6e3;
`;

export const ArrowContainer = styled.div`
  width: 100%;
  padding-top: 100%;
`;

export const Arrow = styled.img`
  width: 20%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const RightSideBox = styled.div`
  width: 78.95%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff9000;
`;

export const TextBox = styled.p`
  width: 100%;
  text-align: center;
  font-weight: 300;
  letter-spacing: 0.6em;
  color: #ffffff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.86vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 1.64vw;
  }
`;
